import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { NamedLink } from '../../components';
import css from './CompaniesPage.module.css';
import element1 from '../../assets/company-hero-shape1.png';
import element2 from '../../assets/company-hero-shape2.png';
import element3 from '../../assets/company-hero-shape3.png';
import element4 from '../../assets/company-hero-shape4.png';
import { isLocaleGreek, onSendEmail } from '../../util/genericHelpers';

function SectionHero() {
  return (
    <div className={css.heroContainer}>
      <span className={css.shape1}>
        <img src={element1} alt="element" />
      </span>
      <span className={css.shape2}>
        <img src={element2} alt="element" />
      </span>
      <span className={css.shape3}>
        <img src={element3} alt="element" />
      </span>
      <span className={css.shape4}>
        <img src={element4} alt="element" />
      </span>
      <div className={css.contentWidth}>
        <div className={css.heroContent}>
          <h1>
            <FormattedMessage id="CompaniesPage.heading" />
          </h1>
          <p>
            <FormattedMessage id="CompaniesPage.description" />
          </p>
          <div className={css.registerNowBtn}>
            <NamedLink name="ContactPage" className={css.registerBtn}>
              <FormattedMessage id="CompaniesPage.registerButton" />
            </NamedLink>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionHero;
